import { render } from "./route.vue?vue&type=template&id=713a8150"
import script from "./route.vue?vue&type=script&lang=js"
export * from "./route.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__